// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrocasDevolucoesRouteImport } from './routes/trocas-devolucoes'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as RecuperarSenhaRouteImport } from './routes/recuperar-senha'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConfirmarEmailRouteImport } from './routes/confirmar-email'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CarrinhoRouteImport } from './routes/carrinho'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProdutoSlugRouteImport } from './routes/produto.$slug'
import { Route as PedidoIdRouteImport } from './routes/pedido.$id'
import { Route as MinhaContaPedidosRouteImport } from './routes/minha-conta/pedidos'
import { Route as MinhaContaFavoritosRouteImport } from './routes/minha-conta/favoritos'
import { Route as MinhaContaEnderecosRouteImport } from './routes/minha-conta/enderecos'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsuariosRouteImport } from './routes/admin/usuarios'
import { Route as AdminPedidosRouteImport } from './routes/admin/pedidos'
import { Route as AdminIntegracaoTinyRouteImport } from './routes/admin/integracao-tiny'
import { Route as AdminConfiguracoesRouteImport } from './routes/admin/configuracoes'
import { Route as AdminClientesRouteImport } from './routes/admin/clientes'
import { Route as AdminProdutosIndexRouteImport } from './routes/admin/produtos/index'
import { Route as AdminCuponsIndexRouteImport } from './routes/admin/cupons/index'
import { Route as AdminCategoriasIndexRouteImport } from './routes/admin/categorias/index'
import { Route as AdminProdutosNovoRouteImport } from './routes/admin/produtos/novo'
import { Route as AdminProdutosIdRouteImport } from './routes/admin/produtos/$id'
import { Route as AdminCuponsNovoRouteImport } from './routes/admin/cupons/novo'
import { Route as AdminCuponsIdRouteImport } from './routes/admin/cupons/$id'
import { Route as AdminCategoriasNovoRouteImport } from './routes/admin/categorias/novo'
import { Route as AdminCategoriasIdRouteImport } from './routes/admin/categorias/$id'

const TrocasDevolucoesRoute = TrocasDevolucoesRouteImport.update({
            id: '/trocas-devolucoes',path: '/trocas-devolucoes',getParentRoute: () => rootRouteImport
          })
const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
            id: '/redefinir-senha',path: '/redefinir-senha',getParentRoute: () => rootRouteImport
          })
const RecuperarSenhaRoute = RecuperarSenhaRouteImport.update({
            id: '/recuperar-senha',path: '/recuperar-senha',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ConfirmarEmailRoute = ConfirmarEmailRouteImport.update({
            id: '/confirmar-email',path: '/confirmar-email',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CarrinhoRoute = CarrinhoRouteImport.update({
            id: '/carrinho',path: '/carrinho',getParentRoute: () => rootRouteImport
          })
const CadastroRoute = CadastroRouteImport.update({
            id: '/cadastro',path: '/cadastro',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProdutoSlugRoute = ProdutoSlugRouteImport.update({
            id: '/produto/$slug',path: '/produto/$slug',getParentRoute: () => rootRouteImport
          })
const PedidoIdRoute = PedidoIdRouteImport.update({
            id: '/pedido/$id',path: '/pedido/$id',getParentRoute: () => rootRouteImport
          })
const MinhaContaPedidosRoute = MinhaContaPedidosRouteImport.update({
            id: '/minha-conta/pedidos',path: '/minha-conta/pedidos',getParentRoute: () => rootRouteImport
          })
const MinhaContaFavoritosRoute = MinhaContaFavoritosRouteImport.update({
            id: '/minha-conta/favoritos',path: '/minha-conta/favoritos',getParentRoute: () => rootRouteImport
          })
const MinhaContaEnderecosRoute = MinhaContaEnderecosRouteImport.update({
            id: '/minha-conta/enderecos',path: '/minha-conta/enderecos',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminUsuariosRoute = AdminUsuariosRouteImport.update({
            id: '/usuarios',path: '/usuarios',getParentRoute: () => AdminRouteRoute
          })
const AdminPedidosRoute = AdminPedidosRouteImport.update({
            id: '/pedidos',path: '/pedidos',getParentRoute: () => AdminRouteRoute
          })
const AdminIntegracaoTinyRoute = AdminIntegracaoTinyRouteImport.update({
            id: '/integracao-tiny',path: '/integracao-tiny',getParentRoute: () => AdminRouteRoute
          })
const AdminConfiguracoesRoute = AdminConfiguracoesRouteImport.update({
            id: '/configuracoes',path: '/configuracoes',getParentRoute: () => AdminRouteRoute
          })
const AdminClientesRoute = AdminClientesRouteImport.update({
            id: '/clientes',path: '/clientes',getParentRoute: () => AdminRouteRoute
          })
const AdminProdutosIndexRoute = AdminProdutosIndexRouteImport.update({
            id: '/produtos/',path: '/produtos/',getParentRoute: () => AdminRouteRoute
          })
const AdminCuponsIndexRoute = AdminCuponsIndexRouteImport.update({
            id: '/cupons/',path: '/cupons/',getParentRoute: () => AdminRouteRoute
          })
const AdminCategoriasIndexRoute = AdminCategoriasIndexRouteImport.update({
            id: '/categorias/',path: '/categorias/',getParentRoute: () => AdminRouteRoute
          })
const AdminProdutosNovoRoute = AdminProdutosNovoRouteImport.update({
            id: '/produtos/novo',path: '/produtos/novo',getParentRoute: () => AdminRouteRoute
          })
const AdminProdutosIdRoute = AdminProdutosIdRouteImport.update({
            id: '/produtos/$id',path: '/produtos/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminCuponsNovoRoute = AdminCuponsNovoRouteImport.update({
            id: '/cupons/novo',path: '/cupons/novo',getParentRoute: () => AdminRouteRoute
          })
const AdminCuponsIdRoute = AdminCuponsIdRouteImport.update({
            id: '/cupons/$id',path: '/cupons/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminCategoriasNovoRoute = AdminCategoriasNovoRouteImport.update({
            id: '/categorias/novo',path: '/categorias/novo',getParentRoute: () => AdminRouteRoute
          })
const AdminCategoriasIdRoute = AdminCategoriasIdRouteImport.update({
            id: '/categorias/$id',path: '/categorias/$id',getParentRoute: () => AdminRouteRoute
          })





const AdminRouteRouteChildren = {
  AdminClientesRoute: AdminClientesRoute,AdminConfiguracoesRoute: AdminConfiguracoesRoute,AdminIntegracaoTinyRoute: AdminIntegracaoTinyRoute,AdminPedidosRoute: AdminPedidosRoute,AdminUsuariosRoute: AdminUsuariosRoute,AdminIndexRoute: AdminIndexRoute,AdminCategoriasIdRoute: AdminCategoriasIdRoute,AdminCategoriasNovoRoute: AdminCategoriasNovoRoute,AdminCuponsIdRoute: AdminCuponsIdRoute,AdminCuponsNovoRoute: AdminCuponsNovoRoute,AdminProdutosIdRoute: AdminProdutosIdRoute,AdminProdutosNovoRoute: AdminProdutosNovoRoute,AdminCategoriasIndexRoute: AdminCategoriasIndexRoute,AdminCuponsIndexRoute: AdminCuponsIndexRoute,AdminProdutosIndexRoute: AdminProdutosIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRouteRoute: AdminRouteRouteWithChildren,CadastroRoute: CadastroRoute,CarrinhoRoute: CarrinhoRoute,CheckoutRoute: CheckoutRoute,ConfirmarEmailRoute: ConfirmarEmailRoute,LoginRoute: LoginRoute,PrivacidadeRoute: PrivacidadeRoute,RecuperarSenhaRoute: RecuperarSenhaRoute,RedefinirSenhaRoute: RedefinirSenhaRoute,TermosRoute: TermosRoute,TrocasDevolucoesRoute: TrocasDevolucoesRoute,MinhaContaEnderecosRoute: MinhaContaEnderecosRoute,MinhaContaFavoritosRoute: MinhaContaFavoritosRoute,MinhaContaPedidosRoute: MinhaContaPedidosRoute,PedidoIdRoute: PedidoIdRoute,ProdutoSlugRoute: ProdutoSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)